
<app-sidebar></app-sidebar>
<div class="main-content d-flex flex-column">
    <app-admin-header></app-admin-header>
    <router-outlet></router-outlet>
    <div class="flex-grow-1"></div>
    <app-admin-footer></app-admin-footer>
</div>
